import React, { useState, useEffect ,useCallback } from 'react';
import {
  Card, Row, Col, Statistic, Typography, Layout, theme,
  Progress, Space, Spin, FloatButton, DatePicker, Button,
  Table, Tag, Avatar, Tooltip
} from 'antd';
import {
  ProjectOutlined, FolderOpenOutlined, CheckCircleOutlined,
  WarningOutlined, PauseCircleOutlined, FileTextOutlined,
  CloseCircleOutlined, UserOutlined, ClockCircleOutlined,
  CalendarOutlined, SyncOutlined, UpOutlined,
  DashboardOutlined, TeamOutlined
} from '@ant-design/icons';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid,
  Tooltip as RechartsTooltip, ResponsiveContainer
} from 'recharts';
import api from '../api/Api';
import dayjs from 'dayjs';

const { Title, Text } = Typography;
const { Content } = Layout;
const { useToken } = theme;
const { RangePicker } = DatePicker;

const DashboardDirecao = () => {
  const { token } = useToken();

  // Estado do período
  const [dateRange, setDateRange] = useState([
    dayjs().startOf('month'),
    dayjs()
  ]);
  const [loading, setLoading] = useState(false);

  // Dados das APIs
  const [projetoMetrics, setProjetoMetrics] = useState({
    total: 0, aberto: 0, fechado: 0, suspenso: 0, foraPrazo: 0
  });
  const [tarefaDirecao, setTarefaDirecao] = useState({
    total: 0, aberto: 0, fechado: 0, suspenso: 0, rejeitada: 0
  });
  const [assiduidadeData, setAssiduidadeData] = useState(null);
  const [tarefasMensais, setTarefasMensais] = useState([]);


// 1. Envolva fetchData em useCallback (coloque ANTES dos useEffects) 
const fetchData = useCallback(async () => {

  setLoading(true);
  const userStored = JSON.parse(localStorage.getItem("user"));

  try {

    const inicio = dateRange?.[0] || dayjs().startOf('month');
    const fim = dateRange?.[1] || dayjs();

    const dataInicio = inicio.format('YYYY-MM-DD');
    const dataFim = fim.format('YYYY-MM-DD');

 

    const payload = {
      dataInicio: dataInicio,
     dataFim: dataFim,
      id_direcao: userStored?.direcao,
    };

    const [projetoRes, tarefaRes, assiduidadeRes, tarefasMesRes] =
      await Promise.all([
        api.ListProjetoMetrica(payload),
        api.ListTarefaDirecao(payload),
        api.ListAssiduidadeDirecao(payload),
        api.ListTarefasFechadasMesDirecao(payload)
      ]);

    setProjetoMetrics(projetoRes || {});
    setTarefaDirecao(tarefaRes || {});
    setAssiduidadeData(assiduidadeRes?.data || null);
    setTarefasMensais(tarefasMesRes || []);

  } catch (error) {

    console.error(error);

  } finally {

    setLoading(false);

  }

}, [dateRange]);

// 2. useEffect do título (só no mount)
useEffect(() => {
  document.title = "Dashboard da Direção - TECH NEXT CRM";
}, []);

// 3. useEffect que reage ao fetchData (dispara no mount e ao mudar dateRange)
useEffect(() => {
  fetchData();
 
}, [fetchData]);
 

  // ==================== CARDS DE PROJETOS ====================
  const ProjetosCards = () => {
    const completionPercent = projetoMetrics.total > 0
      ? Math.round((projetoMetrics.fechado / projetoMetrics.total) * 100)
      : 0;
    const overduePercent = projetoMetrics.total > 0
      ? Math.round((projetoMetrics.foraPrazo / projetoMetrics.total) * 100)
      : 0;

    return (
      <>
        <Title level={4} style={{ marginBottom: 16 }}>
          <ProjectOutlined /> Projetos
        </Title>
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
          {/* Total Projetos */}
          <Col xs={24} sm={12} lg={8}>
            <Card hoverable style={{
              background: `linear-gradient(135deg, ${token.colorPrimary} 0%, ${token.colorPrimaryActive} 100%)`,
              borderRadius: '12px', border: 'none',
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)', height: '100%'
            }} bodyStyle={{ padding: '20px' }}>
              <Statistic
                title={<Space style={{ color: 'white', opacity: 0.9 }}><ProjectOutlined /><Text style={{ color: 'white' }}>Total</Text></Space>}
                value={projetoMetrics.total}
                valueStyle={{ color: 'white', fontSize: '32px', fontWeight: 'bold' }}
                prefix={<ProjectOutlined />}
              />
              <div style={{ marginTop: 12 }}>
                <Progress percent={completionPercent} strokeColor="white"
                  trailColor="rgba(255,255,255,0.2)" showInfo={false} size="small" />
                <Text style={{ color: 'white', fontSize: 12, display: 'block', marginTop: 4 }}>
                  {completionPercent}% concluídos
                </Text>
              </div>
            </Card>
          </Col>

          {/* Projetos Concluídos */}
          <Col xs={24} sm={12} lg={8}>
            <Card hoverable style={{
              background: `linear-gradient(135deg, ${token.colorSuccess} 0%, ${token.colorSuccessActive} 100%)`,
              borderRadius: '12px', border: 'none',
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)', height: '100%'
            }} bodyStyle={{ padding: '20px' }}>
              <Statistic
                title={<Space style={{ color: 'white', opacity: 0.9 }}><CheckCircleOutlined /><Text style={{ color: 'white' }}>Concluídos</Text></Space>}
                value={projetoMetrics.fechado}
                valueStyle={{ color: 'white', fontSize: '32px', fontWeight: 'bold' }}
                prefix={<CheckCircleOutlined />}
              />
              <div style={{ marginTop: 12 }}>
                <Progress percent={completionPercent} strokeColor="white"
                  trailColor="rgba(255,255,255,0.2)" showInfo={false} size="small" />
              </div>
            </Card>
          </Col>

          {/* Fora do Prazo */}
          <Col xs={24} sm={12} lg={8}>
            <Card hoverable style={{
              background: `linear-gradient(135deg, ${token.colorWarning} 0%, ${token.colorWarningActive} 100%)`,
              borderRadius: '12px', border: 'none',
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)', height: '100%'
            }} bodyStyle={{ padding: '20px' }}>
              <Statistic
                title={<Space style={{ color: 'white', opacity: 0.9 }}><WarningOutlined /><Text style={{ color: 'white' }}>Fora do Prazo</Text></Space>}
                value={projetoMetrics.foraPrazo}
                valueStyle={{ color: 'white', fontSize: '32px', fontWeight: 'bold' }}
                prefix={<WarningOutlined />}
              />
              <div style={{ marginTop: 12 }}>
                <Progress percent={overduePercent} strokeColor="white"
                  trailColor="rgba(255,255,255,0.2)" showInfo={false} size="small" />
              </div>
            </Card>
          </Col>
        </Row>

        {/* Cards secundários */}
        <Row gutter={[16, 16]} style={{ marginBottom: 32 }}>
          <Col xs={24} sm={12}>
            <Card size="small" hoverable>
              <Statistic
                title="Abertos"
                value={projetoMetrics.aberto}
                prefix={<FolderOpenOutlined />}
                valueStyle={{ color: token.colorInfo }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12}>
            <Card size="small" hoverable>
              <Statistic
                title="Suspensos"
                value={projetoMetrics.suspenso}
                prefix={<PauseCircleOutlined />}
                valueStyle={{ color: token.colorWarning }}
              />
            </Card>
          </Col>
        </Row>
      </>
    );
  };

  // ==================== CARDS DE TAREFAS DA DIREÇÃO ====================
  
const TarefasDirecaoCards = () => {
  return (
    <>
      <Title level={4} style={{ marginBottom: 16 }}>
        <FileTextOutlined /> Tarefas da Direção
      </Title>
      <Row gutter={[16, 16]} style={{ marginBottom: 32 }}>
        <Col flex={1}>
          <Card hoverable size="small">
            <Statistic
              title="Total"
              value={tarefaDirecao.total}
              prefix={<FileTextOutlined />}
              valueStyle={{ color: token.colorPrimary }}
            />
          </Card>
        </Col>
        <Col flex={1}>
          <Card hoverable size="small">
            <Statistic
              title="Concluídas"
              value={tarefaDirecao.fechado}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: token.colorSuccess }}
            />
          </Card>
        </Col>
        <Col flex={1}>
          <Card hoverable size="small">
            <Statistic
              title="Abertas"
              value={tarefaDirecao.aberto}
              prefix={<FolderOpenOutlined />}
              valueStyle={{ color: token.colorInfo }}
            />
          </Card>
        </Col>
        <Col flex={1}>
          <Card hoverable size="small">
            <Statistic
              title="Suspensas"
              value={tarefaDirecao.suspenso}
              prefix={<PauseCircleOutlined />}
              valueStyle={{ color: token.colorWarning }}
            />
          </Card>
        </Col>
        <Col flex={1}>
          <Card hoverable size="small">
            <Statistic
              title="Rejeitadas"
              value={tarefaDirecao.rejeitada}
              prefix={<CloseCircleOutlined />}
              valueStyle={{ color: token.colorError }}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};

  // ==================== GRÁFICO DE TAREFAS FECHADAS POR MÊS ====================
  const TarefasMensaisChart = () => (
    <Card
      title={
        <Space>
          <CalendarOutlined />
          <span>Tarefas Concluídas por Mês (Direção)</span>
        </Space>
      }
      style={{ borderRadius: '12px', marginBottom: '24px' }}
      hoverable
    >
      <div style={{ height: '350px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={tarefasMensais}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient id="colorTarefasMesDirecao" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={token.colorPrimary} stopOpacity={0.8} />
                <stop offset="95%" stopColor={token.colorPrimary} stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke={token.colorBorder} />
            <XAxis
              dataKey="mes"
              tick={{ fill: token.colorTextSecondary }}
              axisLine={{ stroke: token.colorBorder }}
            />
            <YAxis
              tick={{ fill: token.colorTextSecondary }}
              axisLine={{ stroke: token.colorBorder }}
              allowDecimals={false}
            />
            <RechartsTooltip
              contentStyle={{
                backgroundColor: token.colorBgContainer,
                border: `1px solid ${token.colorBorder}`,
                borderRadius: '8px'
              }}
            />
            <Area
              type="monotone"
              dataKey="total"
              stroke={token.colorPrimary}
              fillOpacity={1}
              fill="url(#colorTarefasMesDirecao)"
              strokeWidth={2}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );

  // ==================== ASSIDUIDADE ====================
    const cardStyle = {
  borderRadius: '12px',
  height: '120px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between'
};
  
  const AssiduidadeSection = () => {
    if (!assiduidadeData) return null;

    const columns = [
      {
        title: '#',
        key: 'index',
        width: 50,
        render: (_, __, index) => (
          <Avatar size="small" style={{ backgroundColor: token.colorPrimary }}>
            {index + 1}
          </Avatar>
        ),
      },
      {
        title: 'Funcionário',
        dataIndex: 'nome',
        key: 'nome',
        render: (text) => (
          <Space>
            <UserOutlined />
            <Text>{text}</Text>
          </Space>
        ),
      },
      {
        title: 'ID',
        dataIndex: 'employee_id',
        key: 'employee_id',
        render: (text) => <Tag color="blue">{text}</Tag>,
      },
      {
        title: 'Assiduidade',
        dataIndex: 'assiduidade',
        key: 'assiduidade',
        render: (text) => (
          <Space>
            <Progress
              percent={parseInt(text) || 0}
              size="small"
              strokeColor={token.colorSuccess}
              showInfo={false}
              style={{ width: 80 }}
            />
            <Text style={{ whiteSpace: 'nowrap' }}>{text}</Text>
          </Space>
        ),
      },
      {
        title: 'Pontualidade',
        dataIndex: 'pontualidade',
        key: 'pontualidade',
        render: (text) => (
          <Space>
            <Progress
              percent={parseInt(text) || 0}
              size="small"
              strokeColor={token.colorPrimary}
              showInfo={false}
              style={{ width: 80 }}
            />
            <Text style={{ whiteSpace: 'nowrap' }}>{text}</Text>
          </Space>
        ),
      },
      {
        title: 'Trabalhados / Úteis',
        key: 'dias',
        render: (_, record) => (
          <Text>{record.dias_trabalhados} / {record.dias_uteis}</Text>
        ),
      },
      {
        title: 'Faltas (Just.)',
        key: 'faltas',
        render: (_, record) => (
          <Space>
            <Tag color="warning">{record.faltas}</Tag>
            {record.faltas_justificadas > 0 && (
              <Tag color="default">{record.faltas_justificadas} just.</Tag>
            )}
          </Space>
        ),
      },
    ];

    return (
      <>
        <Title level={4} style={{ marginBottom: 16 }}>
          <TeamOutlined /> Assiduidade da Direção
        </Title>
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
          <Col xs={24} sm={8}>
            <Card hoverable size="small" style={cardStyle}>
              <Statistic
                title="Média de Assiduidade"
                value={assiduidadeData.resumo.media_assiduidade}
                prefix={<UserOutlined />}
                valueStyle={{ color: token.colorSuccess }}
              />
              <Progress
                percent={parseInt(assiduidadeData.resumo.media_assiduidade) || 0}
                strokeColor={token.colorSuccess}
                size="small"
                showInfo={false}
              />
            </Card>
          </Col>
          <Col xs={24} sm={8}>
            <Card hoverable size="small" style={cardStyle}>
              <Statistic
                title="Média de Pontualidade"
                value={assiduidadeData.resumo.media_pontualidade}
                prefix={<ClockCircleOutlined />}
                valueStyle={{ color: token.colorPrimary }}
              />
              <Progress
                percent={parseInt(assiduidadeData.resumo.media_pontualidade) || 0}
                strokeColor={token.colorPrimary}
                size="small"
                showInfo={false}
              />
            </Card>
          </Col>
          <Col xs={24} sm={8}>
            <Card hoverable size="small" style={cardStyle}>
              <Statistic
                title="Total de Funcionários"
                value={assiduidadeData.resumo.total_funcionarios}
                prefix={<TeamOutlined />}
                valueStyle={{ color: token.colorInfo }}
              />
            </Card>
          </Col>
        </Row>

        <Card
          title="Detalhamento por Funcionário"
          style={{ borderRadius: '12px', marginBottom: 32 }}
          hoverable
        >
          <Table
            columns={columns}
            dataSource={assiduidadeData.funcionarios.map((f, idx) => ({ ...f, key: idx }))}
            pagination={false}
            size="small"
            loading={loading}
            scroll={{ x: 800 }}
          />
        </Card>
      </>
    );
  };

  // ==================== RENDER PRINCIPAL ====================
  return (
    <Layout style={{ minHeight: '100vh', background: token.colorBgLayout }}>
      <Content style={{ padding: '24px', overflow: 'auto', height: '100vh' }}>
        {/* Overlay de carregamento */}
        {loading && (
          <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(255,255,255,0.7)', display: 'flex',
            justifyContent: 'center', alignItems: 'center', zIndex: 1000
          }}>
            <Spin size="large" tip="Carregando métricas da direção..." />
          </div>
        )}

        {/* Cabeçalho */}
        <div style={{
          marginBottom: 24, display: 'flex',
          justifyContent: 'space-between', alignItems: 'center',
          flexWrap: 'wrap', gap: 16
        }}>
         
          <Space>
            <RangePicker
              value={dateRange}
              onChange={(dates) => setDateRange(dates)}
              format="DD/MM/YYYY"
              allowClear={false}
            />
            <Button
              icon={<SyncOutlined />}
              onClick={fetchData}
              loading={loading}
            >
              Atualizar
            </Button>
          </Space>
        </div>

        {/* Seções */}
        <ProjetosCards />
        <TarefasDirecaoCards />
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
          <Col xs={24}>
            <TarefasMensaisChart />
          </Col>
        </Row>
        <AssiduidadeSection />

        {/* Botões flutuantes */}
        <FloatButton.BackTop
          icon={<UpOutlined />}
          style={{ right: 24, bottom: 24 }}
          visibilityHeight={300}
        />
        <FloatButton
          icon={<SyncOutlined spin={loading} />}
          onClick={fetchData}
          tooltip="Atualizar dados"
          style={{ right: 24, bottom: 80 }}
        />
      </Content>
    </Layout>
  );
};

export default DashboardDirecao;